"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSolendExchangeRate = exports.getSolendReserveMapping = void 0;
const anchor = __importStar(require("@project-serum/anchor"));
const solendSdk = __importStar(require("@solendprotocol/solend-sdk"));
const constants_1 = require("./constants");
const bignumber_js_1 = __importDefault(require("bignumber.js"));
function getSolendReserveMapping(network, tokenAddress) {
    let solendReserve = constants_1.SOLEND_C_TOKEN_RESERVE_MAP[network][tokenAddress.toString()];
    return solendReserve != undefined ? solendReserve : undefined;
}
exports.getSolendReserveMapping = getSolendReserveMapping;
async function getSolendExchangeRate(connection, reserveAcc) {
    let reserveInfo = await connection.getAccountInfo(reserveAcc);
    let reserveDecoded = solendSdk.ReserveLayout.decode(reserveInfo.data);
    let totalBorrowsWads = reserveDecoded.liquidity.borrowedAmountWads;
    let totalLiquidityWads = reserveDecoded.liquidity.availableAmount.mul(new anchor.BN(constants_1.WAD));
    let totalDepositsWads = totalBorrowsWads.add(totalLiquidityWads);
    const cTokenExchangeRate = new bignumber_js_1.default(totalDepositsWads.toString())
        .div(reserveDecoded.collateral.mintTotalSupply.toString())
        .div(constants_1.WAD)
        .toNumber();
    return cTokenExchangeRate;
}
exports.getSolendExchangeRate = getSolendExchangeRate;
